import { ProfileNotCompletedChallengeCategorySkeleton } from './profile-not-completed-challenge-category-skeleton'
import React from 'react'

export const ProfileNotCompletedChallengesSkeleton = (): React.ReactElement => {
  return (
    <>
      <ProfileNotCompletedChallengeCategorySkeleton />
      <ProfileNotCompletedChallengeCategorySkeleton />
    </>
  )
}
